import React from 'react';
import { Button } from '@ui';
import { Popup } from '@progress/kendo-react-popup';
import ClickAwayListener from 'react-click-away-listener';
import { translate } from '@utils/i18n';
import { namespace } from '../constants';
function RichResourceActions({ resourceName, onEditResource, onDeleteEntry }) {
    const anchor = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const handleToggleOpen = React.useCallback(() => {
        setOpen(true);
    }, []);
    const handleClose = React.useCallback(() => {
        setOpen(false);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "highlighted", onClick: handleToggleOpen, ref: anchor },
            React.createElement("i", { className: "fa-light fa-ellipsis" })),
        React.createElement(Popup, { anchor: anchor.current, show: open, onClose: handleClose },
            React.createElement(ClickAwayListener, { onClickAway: handleClose },
                React.createElement("div", { id: "popup_convert", className: "qmb-popup--action-list" },
                    React.createElement("ul", { role: "presentation" },
                        resourceName && (React.createElement("li", { role: "presentation" },
                            React.createElement("button", { type: "button", onClick: () => {
                                    onEditResource();
                                    handleClose();
                                } },
                                React.createElement("i", { className: "fa-light fa-pencil" }),
                                translate('update_resource', { namespace, resource: resourceName })))),
                        React.createElement("li", { role: "presentation" },
                            React.createElement("button", { type: "button", onClick: () => {
                                    onDeleteEntry();
                                    handleClose();
                                } },
                                React.createElement("i", { className: "fa-light fa-trash-can" }),
                                translate('delete', { namespace: 'features.commons' })))))))));
}
export default React.memo(RichResourceActions);
